export class Approval{
    isApproved:boolean = false;
    approvedBy:string = '';
    note:string = '';
}